import styled from "styled-components";
import { colors, breakpoints } from "../../../styles/variables";

export const SButton = styled.button`
    background-color: ${({ disabled }) => disabled ? colors.gray : colors.paypoGreen500 };
    color: ${ colors.black };
    font-family: 'Gilroy', sans-serif;
    font-weight: 800;
    font-size: 1.6rem;
    line-height; 2.4rem;
    padding: 1.5rem 4rem;
    text-align: center;
    width: 100%;
    max-width: 30rem;
    cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
    border: none;
    border-radius: 2.6rem;

    &.textButton {
        padding: 0;
        background: none;
        color: ${ colors.paypoDarkGreen };
    }

    &.black {
        color: ${ colors.white };
        background-color: ${({ disabled }) => disabled ? colors.gray : colors.black };
        border: 2px solid ${ colors.black };

        &:hover {
            color: ${ colors.black };
            background-color: ${({ disabled }) => disabled ? colors.gray : colors.white };
        }
    }

    &:hover {
        background-color: ${({ disabled }) => disabled ? colors.gray : colors.paypoGreen400 };
        
        &.textButton {
            background: none;
        }
    }

    @media (min-width: ${ breakpoints.medium }) {
        width: initial;
    }
`;
